// Operating system and Browser names:
//  https://github.com/lancedikson/bowser/blob/master/src/constants.js
// Support initially follows MUI support:
//  https://mui.com/getting-started/supported-platforms/
//  https://github.com/mui/material-ui/blob/master/.browserslistrc#L12-L27
// Format examples:
//  https://www.npmjs.com/package/bowser#filtering-browsers
export const unsupportedBrowsers = {
  // Android: {
  // chrome: "<91",
  // firefox: "<89",
  // },
  // android: "<91",
  MacOS: {
    safari: "<14",
  },
  iOS: {
    safari: "<10",
  },
  ie: "<12",
  // safari: "<12",
  // edge: "<91",
  // firefox: "<78",
  // chrome: "<90",
  // baidu: "<7.12",
  // kaios: "<2.5",
  // opera: "<76",
  // samsung: "<13",
};
